import { makeStyles } from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';

import { ReactComponent as WorkReportsAdd } from './avariya_dobavyane_icon.svg';

const useStyles = makeStyles({
  icon: {
    width: '20x',
    height: '20px',
    fill: '#3b3c3c',
    '& .st0': {
      fill: '#3b3c3c',
    },
  },
});

export default function WorkReportsAddIcon() {
  const classes = useStyles();

  return (
    <SvgIcon className={classes.icon} viewBox="0 0 24 24">
      <WorkReportsAdd />
    </SvgIcon>
  );
}
